import PropTypes from 'prop-types';

import { FeatureService } from '@spotahome/ui-library';

import ListingTitle from './ListingTitle';

import './ListingDetailsFeaturesChips.scss';
import ListingChipsContainer from './ListingChipsContainer';

const formatFeatures = features => {
  const parsedFeatures = Object.entries(features).reduce((acc, current, i) => {
    const [key, value] = current;
    return {
      ...acc,
      [key]: {
        value,
        order: i
      }
    };
  }, {});
  return FeatureService.getFeaturesAsList(parsedFeatures);
};

const ListingDetailsFeaturesChips = ({ title, features }) => (
  <div className="listing-features">
    <ListingTitle role="tertiary">{title}</ListingTitle>
    <ListingChipsContainer chipList={formatFeatures(features)} />
  </div>
);

ListingDetailsFeaturesChips.propTypes = {
  title: PropTypes.string.isRequired,
  features: PropTypes.shape({
    [PropTypes.string]: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  }).isRequired
};

export default ListingDetailsFeaturesChips;
